<template>
   <div class="flex justify-self-stretch absolute top-[1vw] left-[0vw] group">
        <SetaEsquerda class="pb:text-white text-primary group-hover:text-blue-600 w-4"/>
        <button @click="goBack" :class="stateBack" class="back-sm text-xs hover:text-blue-600 hover:underline pb:text-white sm:text-primary">Voltar</button>
    </div>
</template>

<script>
import SetaEsquerda from "@/Components/UI/Icons/SetaEsquerda.vue"
export default {
  components: { SetaEsquerda },
  props:
    {
        state: String
    },

    data() {


    return {
      SetaEsquerda,
    };
  },
  methods: {

    goBack(){
      return window.history.go(-1);
    }
  },
  computed: {
        stateBack() {
            if (this.state == "back-sm") {
                return "text-gray-500 text-sm";
            }
            if (this.state == "back-md") {
                return "text-gray-500 text-md";
            }
            return "text-gray-700";
        },
    },

};
</script>
